<template>
  <span class="brand-mark" aria-hidden="true">
    <img src="/brand/nova-logo.png" alt="" />
  </span>
</template>
